import React, { Fragment, useContext, useEffect } from "react";

import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs, Btn } from "../../AbstractElements";

import { Users } from "../../Shared/Constants";
import DataTableUsersComponent from "./DataTableUsersComponent";
import TableSearch from "../../Shared/Components/Search/TableSearch";

import UserContext from "./ContextProvider";
import { PlusCircle } from "react-feather";
import UserForm from "./UserForm";
import { hasPermission } from "../../Shared/Utils/userUtils";

const UserList = () => {
  const { modalTogle, setItem, setSearchTerm } = useContext(UserContext);
  const handleNew = (row) => {
    setItem({});
    modalTogle();
  };

  useEffect(() => {
    return () => {
      setSearchTerm("");
    };
  }, []);

  return (
    <Fragment>
      <Breadcrumbs parent="Admin" title={Users} mainTitle={Users} />
      <Container fluid={true}>
        <Row>
          {/* <ListHeader></ListHeader> */}
          <Col sm="12">
            <Card>
              <CardBody className="data-tables">
                <Row className="project-list">
                  <Col md="4">
                    <TableSearch onSearch={setSearchTerm} />
                  </Col>
                  <Col sm="8" className="p-0">
                    {hasPermission("create_user") ? (
                      <div className="text-end">
                        <Btn
                          attrBtn={{
                            color: "primary",
                            className: "btn btn-primary text-white",
                            onClick: handleNew,
                          }}
                        >
                          <PlusCircle />
                          Nuevo Usuario
                        </Btn>
                        <UserForm />
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md="12">
                    <DataTableUsersComponent />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default UserList;
